export default function chooseItem(className, event) {
  const items = document.querySelectorAll(className);

  items.forEach((e) => {
    e.classList.remove("active");
  });
  event.target.classList.add("active");
}
